import React from 'react'
import styled from '@emotion/styled'
import mq from '../styles/mediaQueries'
import { Link } from 'gatsby'

import aboutGIF from '../assets/animations/about.gif'
import blogGIF from '../assets/animations/blog.gif'
import contactGIF from '../assets/animations/contact.gif'
import homeGIF from '../assets/animations/home.gif'
import servicesGIF from '../assets/animations/services.gif'
import workGIF from '../assets/animations/work.gif'

import Contact from './Contact'
import { Headline1 } from './Typography'

const OverlayWrapper = styled.div`
  ${mq({
    left: ['12px', '12px', '71px', '71px', '71px'],
  })};
  top: 71px;
  position: fixed;
  opacity: 1;
  z-index: 5;
  display: ${props => (props.isOverlayOpen ? 'block' : 'none')};
`

const OverlayList = styled.ul`
  position: fixed;
  display: flex;
  flex-direction: column;
  padding-inline-start: 0;
  margin-block-start: 0;
  margin-block-end: 0;
`

const OverlayListItems = styled.li`
  ${Headline1};
  list-style: none;
  border: 1px solid var(--screen-400);
  border-width: 0 1px 1px 1px;
  :first-of-type {
    border-width: 1px;
  }

  position: relative;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  background-color: var(--screen-500);
  color: white;

  &:after {
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    left: 0px;
    background-image: url(${props => props.background});
    content: '';
    opacity: 0;
    transition: opacity;
  }

  &:hover {
    &:after {
      opacity: 1;
    }
  }

  ${mq({
    width: [
      'calc(100vw - 24px)',
      'calc(100vw - 24px)',
      'calc(100vw - 83px)',
      'calc(100vw - 83px)',
      'calc(100vw - 83px)',
    ],
    height: [
      'calc((100vh - 83px)/6)',
      'calc((100vh - 83px)/6)',
      'calc((100vh - 83px)/5)',
      'calc((100vh - 83px)/5)',
      'calc((100vh - 83px)/5)',
    ],
    ':last-of-type': {
      display: ['flex', 'flex', 'none', 'none', 'none'],
    },
  })};
`

const OverlayLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  z-index: 2;
  height: 100%;
  display: flex;
  align-items: center;

  ${mq({
    paddingLeft: ['28px', '48px', '48px', '48px', '48px'],
  })};
`

const OverlayContactWrapper = styled.div`
  position: absolute;
  ${mq({
    bottom: ['80px', '60px', '60px', '72px', '60px'],
    right: ['10px', '60px', '60px', '72px', '60px'],
  })};
`

function NavOverlay({ isOverlayOpen, setIsOverlayOpen }) {
  function toggleNav(event) {
    event.preventDefault()
    setIsOverlayOpen(!isOverlayOpen)
  }

  return (
    <React.Fragment>
      <OverlayWrapper isOverlayOpen={isOverlayOpen}>
        <OverlayList>
          <OverlayListItems background={homeGIF} onClick={toggleNav}>
            <OverlayLink to="/">Home</OverlayLink>
          </OverlayListItems>
          <OverlayListItems background={workGIF} onClick={toggleNav}>
            <OverlayLink to="/work">Work</OverlayLink>
          </OverlayListItems>
          <OverlayListItems background={servicesGIF} onClick={toggleNav}>
            <OverlayLink to="/services">Services</OverlayLink>
          </OverlayListItems>
          <OverlayListItems background={aboutGIF} onClick={toggleNav}>
            <OverlayLink to="/about">About</OverlayLink>
          </OverlayListItems>
          <OverlayListItems background={blogGIF} onClick={toggleNav}>
            <OverlayLink to="/blog">Blog</OverlayLink>
          </OverlayListItems>
          <OverlayListItems background={contactGIF} onClick={toggleNav}>
            <OverlayLink to="/contact">Contact</OverlayLink>
          </OverlayListItems>
          <OverlayContactWrapper>
            <Contact colorTheme={'white'} />
          </OverlayContactWrapper>
        </OverlayList>
      </OverlayWrapper>
    </React.Fragment>
  )
}

export default NavOverlay
